export default __webpack_public_path__ + "static/media/ppgm.f8a28201.png";